import { useMemo } from "react";

import EmptyState from "ds/components/EmptyState";
import type { EntityAttributeChange } from "types/generated";

import RunCodeChangesGroup from "./Group";
import { buildAttributeTree } from "./helpers";
import RunCodeChangesRow from "./Row";
import styles from "./styles.module.css";

type RunCodeChangesProps = {
  items: EntityAttributeChange[];
};

const RunCodeChanges = ({ items }: RunCodeChangesProps) => {
  const tree = useMemo(() => buildAttributeTree(items), [items]);

  const nodes = tree.length === 1 && tree[0].kind === "group" ? tree[0].children : tree;

  if (!nodes.length) {
    return <EmptyState title="Not possible to display." />;
  }

  return (
    <div className={styles.wrapper}>
      {nodes.map((node) =>
        node.kind === "group" ? (
          <RunCodeChangesGroup key={node.id} node={node} />
        ) : (
          <RunCodeChangesRow key={node.id} name={node.key} item={node.item} />
        )
      )}
    </div>
  );
};

export default RunCodeChanges;
